import script from "./WorkOtter.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkOtter.vue?vue&type=script&setup=true&lang=js"

import "./WorkOtter.vue?vue&type=style&index=0&id=4569724a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4569724a"]])

export default __exports__